export default {
    computed: {
        uniqueId() {
            return Math.random().toString(36).slice(2)
        },
    }
}